import { useMainState } from "modules/app/contexts";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import * as http from "modules/app/utils/http";
import * as S from "./styles";

export default function MultipleForward({ handleClose }) {
  const [selectedUser, setSelectedUser] = useState();
  const [confirmation, setConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const {
    selectedForwardContacts,
    setSelectedForwardContacts,
    users,
  } = useMainState();

  async function handleSubmit() {
    setLoading(true);
    try {
      await http.multipleCustomersForward(
        selectedForwardContacts,
        selectedUser.id
      );
      handleClose();
      toast.success(t("Contacts:forwardMode.success"));
      setSelectedForwardContacts([]);
    } catch (error) {
      console.log(error);
      toast.error(t("Contacts:forwardMode.error"));
    }
    setLoading(false);
  }

  function handleCancel() {
    setConfirmation(false);
    setSelectedUser();
  }

  function handleSelectUser(user) {
    setConfirmation(true);
    setSelectedUser(user);
  }

  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>{t("Contacts:forwardMode.modalHeader")}</S.ModalTitle>
          <S.CloseButton
            onClick={() => handleClose()}
            aria-label="display more actions"
          >
            <S.CloseIcon />
          </S.CloseButton>
        </S.ModalHeader>
        {confirmation ? (
          <S.Confirmation>
            <S.ConfirmationMessage>
              {t("Contacts:forwardMode.confirmationMessage", {
                count: selectedForwardContacts.length,
                selected_user: selectedUser.name,
              })}
            </S.ConfirmationMessage>
            <S.ConfirmationOptions>
              <S.YesButton onClick={handleSubmit}>
                {loading ? (
                  <S.Loading />
                ) : (
                  t("Contacts:forwardMode.confirmButton")
                )}
              </S.YesButton>
              <S.NoButton onClick={handleCancel} disabled={loading}>
                {t("Contacts:forwardMode.cancelButton")}
              </S.NoButton>
            </S.ConfirmationOptions>
          </S.Confirmation>
        ) : (
          <S.UsersList>
            {users
              .sort((a, b) =>
                a.name.normalize().localeCompare(b.name.normalize())
              )
              .map((user) => (
                <S.UserCard
                  key={user.id}
                  onClick={() => handleSelectUser(user)}
                >
                  <S.UserName>{user.name}</S.UserName>
                </S.UserCard>
              ))}
          </S.UsersList>
        )}
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
